if (!customElements.get('footer-accordion')) {
  class FooterAccordion extends AccordionElement {
    constructor() {
      super();
      this.mobileBreakpoint = '(max-width: 989px)';
      this.details = this.querySelector('details');
      this.summary = this.details.querySelector('summary');
      this.content = this.summary.nextElementSibling;
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      super.attachEvents();

      ['load', 'resize'].forEach((eventName) => {
        window.addEventListener(eventName, () => {
          if (window.matchMedia(this.mobileBreakpoint).matches) {
            this.details.removeAttribute('open');

            this.content.style.maxHeight = 0;
          } else {
            this.details.setAttribute('open', true);
          }
        });
      });

      this.details.addEventListener(
        'toggle',
        this.closeAllAccordions.bind(this),
      );
    }

    closeAllAccordions() {
      if (
        !this.details.hasAttribute('open') ||
        !window.matchMedia(this.mobileBreakpoint).matches
      )
        return;

      const allOpenAccordions = document.querySelectorAll(
        'footer-accordion details[open]',
      );

      allOpenAccordions.forEach((accordion) => {
        if (accordion != this.details) {
          this.close(accordion);
        }
      });
    }
  }

  customElements.define('footer-accordion', FooterAccordion);
}
